var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  color: "#5D5D5D",
  width: 10,
  height: 10,
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  fill: "currentcolor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 3.25A.25.25 0 0 1 5.75 3h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.75 0A.25.25 0 0 1 2 .25V.5h4V.25a.25.25 0 0 1 .5 0V.5H7a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1.5a1 1 0 0 1 1-1h.5V.25A.25.25 0 0 1 1.75 0ZM.5 2v5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V2h-7Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10v10H0z"
})))));
export default SvgCalendar;